import React, { useState, useEffect } from "react";

import "./Dispatcher.css";
import { fetchAllShipments } from "../../../services/shipments.services";
import { useDispatch } from "react-redux";
import BoltTable from "../../../Components/BoltTable/BoltTable";
import columns from "./table.data";
import SelectDriver from "./Components/SelectDriver/SelectDriver";
import { fetchAllDrivers } from "../../../services/drivers.services";
import { showSnackBar } from "../../../store/common/snackBarSlice";
import InvoiceModal from "../../../Components/InvoiceModal/InvoiceModal";
import ShipmentStatusModal from "./Components/ShipmentStatus/ShipmentStatusModal";
import { useTranslation } from "react-i18next";

const Dispatcher = () => {
  const { t } = useTranslation("carrier");
  const [shipments, setShipments] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [selectDriverModal, setSelectDriverModal] = useState();
  const [invoiceModal, setInvoiceModal] = useState();
  const [shipmentStatusModal, setShipmentStatusModal] = useState(false);
  const [refresh, setRefresh] = useState();
  const dispatch = useDispatch();

  const getAllShipments = async (page, perPage, filter) => {
    const response = await fetchAllShipments(page, perPage, filter);

    if (!response.error) {
      setShipments(response?.data?.result?.shipments);
    } else {
      dispatch(
        showSnackBar({
          text:
            response?.error?.response?.data?.message ?? t("common:messages.somethingWentWrong"),
          severity: "error",
        }),
      );
    }
  };

  const getAllDrivers = async (page, perPage, filter) => {
    const response = await fetchAllDrivers(page, perPage, filter);
    if (!response.error) {
      setDrivers(
        response.data.result.data?.map((item) => {
          return { ...item.driver, id: item.id };
        }),
      );
    } else {
      dispatch(
        showSnackBar({
          text:
            response?.error?.response?.data?.message ?? t("common:messages.somethingWentWrong"),
          severity: "error",
        }),
      );
    }
  };

  useEffect(() => {
    getAllDrivers(1, 100, "");
  }, []);

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "5px 5px" }}
    >
      <ShipmentStatusModal
        isOpen={shipmentStatusModal}
        shipmentId={shipmentStatusModal}
        onClose={() => setShipmentStatusModal(false)}
        setShipments={setShipments}
        shipments={shipments}
        drivers={drivers}
        setRefresh={setRefresh}
      />
      <SelectDriver
        open={selectDriverModal}
        setOpen={setSelectDriverModal}
        drivers={drivers}
        setShipments={setShipments}
        getAllDrivers={getAllDrivers}
      />
      <InvoiceModal
        open={!!invoiceModal}
        data={invoiceModal}
        setData={setInvoiceModal}
        setShipments={setShipments}
        setOpen={setInvoiceModal}
      />
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <BoltTable
          tableTitle={t("dispatcher.shipments")}
          message={t("dispatcher.noShipmentsAvailableToDisplay")}
          searchPlaceHolder={t("dispatcher.searchShipments")}
          columns={columns({
            selectDriverModal,
            setSelectDriverModal,
            setShipmentStatusModal,
            invoiceModal,
            setInvoiceModal,
            drivers,
          })}
          data={shipments}
          getAllData={getAllShipments}
          refresh={refresh}
        />
      </div>
    </div>
  );
};

export default Dispatcher;
